import { css } from 'emotion'
// import { LINK_COLOR, LINK_COLOR_DARK  } from 'constants/styleConstants'

export const CancelSubscriptionButtonStyles = css`
  .label {
    vertical-align: middle;
  }
`
